import { SecuredKoppClient } from '../../../../Core/Api/Kopp/SecuredKoppClient';
import { CloseActiveCartCommandRequest } from '../../../../Core/Api/Kopp/Api';
import ConfigUtility from '../../../../Core/ConfigUtility';
import TokenUtility from '../../../../Core/TokenUtility';

export class CheckoutConfirmationHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  CloseCart() {
    const client = new SecuredKoppClient();
    client.showLoading = false;
    client.handleGeneralError = false;

    return client.closeActiveCart(new CloseActiveCartCommandRequest()).then(x => {});
  }
}
